import {ORDER_MAKER_ACTION_CLEAR_WEIGHT_ADJUSTMENT, ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT} from "./types";

export default {
    [ORDER_MAKER_ACTION_CLEAR_WEIGHT_ADJUSTMENT]: ({commit}) => {
        commit(ORDER_MAKER_SETTER_WEIGHT_ADJUSTMENT, {
            adjustment: 0,
            ticker: null,
            batchIds: []
        });
    }
}